'use strict'

class ScrollToTop {
    constructor() {
        this.button = null;
    }

    init() {
        this.button = document.getElementById('scroll-to-top');
        if (this.button) this.setEvent_buttonClick();
    }

    setEvent_buttonClick() {
        const self = this;
        const target = document.body;
        const scrollBehavior = window.matchMedia('(prefers-reduced-motion)').matches ? 'auto' : 'smooth';

        self.button.addEventListener('click', e => {
            if (TPS.polyfill.supportsNativeSmoothScroll) {
                window.scroll({
                    top: 0,
                    behavior: scrollBehavior
                });
            } else {
                TPS.polyfill.smoothScrollTo(0, 500);
            }

            target.setAttribute('tabindex', '-1');
            target.focus();
        });
    }
}